import React from 'react';
import { useI18n } from '../i18n';

const Navigation = ({ activeTab, onTabChange, role }) => {
  const { t } = useI18n();
  const tabs = [
    { id: 'who', label: t('nav_who') },
    { id: 'spaces', label: t('nav_spaces') },
    { id: 'map', label: t('nav_map') },
    { id: 'contact', label: t('nav_contact') },
    ...(role === 'owner' ? [{ id: 'admin', label: 'Admin' }] : []),
  ];

  return (
    <>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`header-tab ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </>
  );
};

export default Navigation;
